import React, { ReactNode } from 'react'
import Layout from 'antd/lib/layout'
import { BREAKPOINTS } from '@features/General'
import Sider from '@components/Navigation'
import Header from '@components/Layouts/Header'
import useWindowSize from 'hooks/processor/useWindowSize'
import styles from './index.scss'

interface IBasicLayout {
    children: ReactNode
}

function BasicLayout(props: IBasicLayout) {
    const { width } = useWindowSize()
    const { children } = props

    return (
        <Layout className={styles['basic-layout']}>
            {width <= BREAKPOINTS.MD && <Sider layoutMode="basic" />}
            <Layout>
                <Header layoutMode="basic" />
                <Layout.Content className={styles['basic-layout__content']}>{children}</Layout.Content>
            </Layout>
        </Layout>
    )
}

export default BasicLayout
